import { MutableRefObject, useEffect, useRef, useState } from 'react';

const useInView = (options: IntersectionObserverInit): [MutableRefObject<HTMLDivElement | null>, boolean] => {
    const [isInView, setIsInView] = useState(false);
    const elementRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (elementRef.current === null) {
            return;
        }
        const elem = elementRef.current;

        const observer = new IntersectionObserver(([entry]) => {
            const style = window.getComputedStyle(elem);
            const isVisible = style.display !== "none" && style.opacity !== "0";
            const hasContent = elem.innerText.trim() !== "" || elem.children.length > 0;

            setIsInView(entry.isIntersecting && isVisible && hasContent);
        }, options);

        observer.observe(elementRef.current);

        return () => {
            if (elementRef.current) {
                observer.unobserve(elementRef.current);
            }
            observer.disconnect();
        };
    }, [options, elementRef]);

    return [elementRef, isInView];
};

export default useInView;
